import { useState, useEffect, useContext } from 'react';
import type { ListContactType } from '@bb/contacts';

import { ContactController } from 'api';
import { message } from 'components';
import { ContactDrawerContext } from 'contexts';
import { useDebounce } from 'hooks';

import { QUERY_START_INDEX, QUERY_SIZE } from './constants';

const useContacts = (contactType: ListContactType) => {
  const { reloadToggle } = useContext(ContactDrawerContext);
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, 500);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        if (debouncedSearchValue) {
          const data = await ContactController.searchContacts(
            debouncedSearchValue,
            contactType,
            QUERY_START_INDEX,
            QUERY_SIZE,
          );

          setContacts(data.active.contacts);
        } else {
          const data = await ContactController.getContactsList(
            contactType,
            QUERY_START_INDEX,
            QUERY_SIZE,
          );

          setContacts(data.contacts);
        }
      } catch (err) {
        message.error('Failed to load clients data');
      } finally {
        setIsLoading(false);
      }
    })();
  }, [debouncedSearchValue, contactType, reloadToggle]);

  return { isLoading, contacts, searchValue, setSearchValue };
};

export default useContacts;
